/**
 * @generated SignedSource<<0fb84a5bb8badb54f43463b7221f9ed7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicTopContentsTopic$data = {
  readonly advertZone: string | null | undefined;
  readonly entityId: string;
  readonly " $fragmentType": "topicTopContentsTopic";
};
export type topicTopContentsTopic$key = {
  readonly " $data"?: topicTopContentsTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicTopContentsTopic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicTopContentsTopic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "version",
          "value": 2
        }
      ],
      "kind": "ScalarField",
      "name": "advertZone",
      "storageKey": "advertZone(version:2)"
    }
  ],
  "type": "Topic",
  "abstractKey": null
};

(node as any).hash = "66f89cd405fab91cc5d96c963cb22db1";

export default node;
